import { useAuth } from "@/auth";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { featureFlags } from "@/config/feature-flag";
import { LogOut } from "lucide-react";

const LogoutButton = () => {
  const { signOut } = useAuth();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="flex items-center gap-2 text-xs text-gray-500 hover:text-gray-700 transition-colors py-1.5 px-2 rounded-md hover:bg-gray-100"
        >
          <LogOut size={14} />
          <span>Sair</span>
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-white">
        <AlertDialogHeader>
          {!featureFlags.USE_KEYCLOAK ? (
            <div>
              <AlertDialogTitle>Você tem certeza absoluta?</AlertDialogTitle>
              <AlertDialogDescription>
                Você será desconectado da sua conta. Caso tenha alguma
                informação não salva, ela será perdida.
              </AlertDialogDescription>
            </div>
          ) : (
            <div>
              <AlertDialogTitle>Você tem certeza absoluta?</AlertDialogTitle>
              <AlertDialogDescription>
                Você será direcionado para o hub. Caso tenha alguma informação
                não salva, ela será perdida.
              </AlertDialogDescription>
            </div>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-md">Cancelar</AlertDialogCancel>
          <AlertDialogAction className="rounded-md" onClick={signOut}>
            Confirmar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default LogoutButton;
